import { AudioManager } from "../AudioManager";

export class SwitchButton extends Phaser.Image {

    public isOn: boolean;

    private textureOn: string;
    private textureOff: string;
    private parentObject: any;

    constructor(game: Phaser.Game, isOn: boolean, textureOn: string, textureOff: string, parentObject: any) {

        super(game, 0, 0, "texture_atlas_1", isOn ? textureOn : textureOff);

        this.isOn = isOn;
        this.textureOn = textureOn;
        this.textureOff = textureOff;
        this.parentObject = parentObject;

        this.inputEnabled = true;
        this.events.onInputDown.add(this.onDown, this);
    }

    private onDown(): void {

        this.isOn = !this.isOn;

        this.frameName = this.isOn ? this.textureOn : this.textureOff;

        this.parentObject.switched(this);

        AudioManager.playSound("click"); 
    }
}
